import { getState } from 'redux/core'


export default getState
